var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 53,
    viewBox: "0 0 58 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8V0.5H12.5V8H20V13H12.5V20.5H7.5V13H0V8H7.5ZM15 23V15.5H22.5V8H40L44.575 13H52.5C55.25 13 57.5 15.25 57.5 18V48C57.5 50.75 55.25 53 52.5 53H12.5C9.75 53 7.5 50.75 7.5 48V23H15ZM32.5 45.5C39.4 45.5 45 39.9 45 33C45 26.1 39.4 20.5 32.5 20.5C25.6 20.5 20 26.1 20 33C20 39.9 25.6 45.5 32.5 45.5ZM24.5 33C24.5 37.425 28.075 41 32.5 41C36.925 41 40.5 37.425 40.5 33C40.5 28.575 36.925 25 32.5 25C28.075 25 24.5 28.575 24.5 33Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCover);
export default __webpack_public_path__ + "static/media/addCover.55caaa81886023c6f88831e3dab628fa.svg";
export { ForwardRef as ReactComponent };